module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "custom"
  }, [_c('s-select', {
    attrs: {
      "el": _vm.el.firstElementChild,
      "custom": "true"
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('blockquote', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.blockquoteShow),
      expression: "blockquoteShow"
    }]
  }, _vm._l((_vm.custom), function(c) {
    return (_vm.selected == c.value) ? _c('div', {
      key: c.value
    }, [_c('simple-element', {
      attrs: {
        "el": c.el
      }
    })], 1) : _vm._e()
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bc62c1f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomSelect.vue
// module id = 452
// module chunks = 1